/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_Bank_Map_To_JobInputs */

const en_story_bank_map_to_job = /** @type {(inputs: Story_Bank_Map_To_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Map to Job`)
};

const de_story_bank_map_to_job = /** @type {(inputs: Story_Bank_Map_To_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Map to Job`)
};

const fr_story_bank_map_to_job = /** @type {(inputs: Story_Bank_Map_To_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Map to Job`)
};

const es_story_bank_map_to_job = /** @type {(inputs: Story_Bank_Map_To_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Map to Job`)
};

const it_story_bank_map_to_job = /** @type {(inputs: Story_Bank_Map_To_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Map to Job`)
};

const nl_story_bank_map_to_job = /** @type {(inputs: Story_Bank_Map_To_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Map to Job`)
};

const pl_story_bank_map_to_job = /** @type {(inputs: Story_Bank_Map_To_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Map to Job`)
};

const fi_story_bank_map_to_job = /** @type {(inputs: Story_Bank_Map_To_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Map to Job`)
};

const da_story_bank_map_to_job = /** @type {(inputs: Story_Bank_Map_To_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Map to Job`)
};

const sv_story_bank_map_to_job = /** @type {(inputs: Story_Bank_Map_To_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Map to Job`)
};

/**
* | output |
* | --- |
* | "Map to Job" |
*
* @param {Story_Bank_Map_To_JobInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const story_bank_map_to_job = /** @type {((inputs?: Story_Bank_Map_To_JobInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Bank_Map_To_JobInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_story_bank_map_to_job(inputs)
	if (locale === "fr") return fr_story_bank_map_to_job(inputs)
	if (locale === "es") return es_story_bank_map_to_job(inputs)
	if (locale === "it") return it_story_bank_map_to_job(inputs)
	if (locale === "nl") return nl_story_bank_map_to_job(inputs)
	if (locale === "pl") return pl_story_bank_map_to_job(inputs)
	if (locale === "fi") return fi_story_bank_map_to_job(inputs)
	if (locale === "da") return da_story_bank_map_to_job(inputs)
	if (locale === "sv") return sv_story_bank_map_to_job(inputs)
	return en_story_bank_map_to_job(inputs)
});